<template>
  <v-row>
    <v-col cols=12>
      <v-card>
        <v-skeleton-loader v-if="$store.state.reminders.retrieveLoader" transition="fade-transition" type="heading" />
        <v-toolbar v-else color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Plantillas de envío de facturas</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <common-templates :templates="remindersTemplates" kind="invoicing" />
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" v-if="$store.state.accounts.retrieveLoader">
      <v-skeleton-loader class="mt-5" transition="fade-transition" type="list-item-three-line" />
    </v-col>
    <v-col cols="12" v-else>
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Preferencias de facturación</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-row class="py-6">
            <v-col md="9">
              <v-list class="v-list-form transparent">
                <v-list-item class="my-3">
                  <v-list-item-title>
                    CCO Emails
                    <v-tooltip right max-width="280px" transition="scale-transition">
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                      </template>
                      <span>Envía como copia oculta los emails de facturas de suscripciones, facturas masivas, facturas manuales y órdenes a las direcciones de correo electrónico especificados.</span>
                    </v-tooltip>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <v-row class="mx-0" v-for="(d, i) in accountSettings.bcc_emails" :key="i">
                      <v-col class="py-1" cols="10">
                        <v-text-field v-model.trim="$v.accountSettings.bcc_emails.$each[i].email.$model" :error="$v.accountSettings.bcc_emails.$each[i].email.$error" hide-details maxlength="64" background-color="white" outlined required single-line dense />
                      </v-col>
                      <v-col class="py-1" cols="1">
                        <v-btn class="mt-1" @click="accountSettings.bcc_emails.splice(i, 1)" icon color="red" retain-focus-on-click :ripple="false"><v-icon small>mdi-close</v-icon></v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="py-0">
                        <v-btn @click="addBccEmail" text color="primary" :ripple="false" :disabled="accountSettings.bcc_emails.length === 3"><v-icon left>mdi-plus</v-icon>Agregar email</v-btn>
                      </v-col>
                    </v-row>
                  </v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer/>
          <v-btn @click="patchAccount" :loading="$store.state.accounts.createLoader" color="primary">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { required, email, maxLength } from 'vuelidate/lib/validators'
import CommonTemplates from '@/views/account/CommonTemplates'
import GenericViewMixin from '@/mixins/GenericViewMixin'

export default {
  components: {
    CommonTemplates
  },
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    accountSettings: {
      bcc_emails: []
    },
    bank: {},
    remindersTemplates: []
  }),
  mounted () {
    this.getTemplates()
  },
  created () {
    this.$store.dispatch('accounts/RETRIEVE', {
      resource: 'accounts',
      id: this.account.id
    })
    .then((response) => {
      if (this.accountSettings.bcc_emails) {
        this.accountSettings.bcc_emails = response.data.bcc_emails.map((email) => {
          return { email: email }
        })
      }
    })
  },
  methods: {
    getTemplates () {
      this.$store.dispatch('reminders/LIST', {
        resource: 'reminders/templates',
        query: { kind: 'invoicing' }
      })
    },
    patchAccount () {
      this.$v.accountSettings.$touch()
      if (this.$v.accountSettings.$invalid) {
        return false
      }
      this.$store.dispatch('accounts/UPDATE', {
        resource: 'accounts',
        payload: {
          bcc_emails: this.accountSettings.bcc_emails.map((obj) => obj.email)
        },
        id: this.account.id
      })
      .then(() => {
        this.$dialog.message.info('Las preferencias de la organización se han actualizado')
      })
      .catch((error) => {
        this.$dialog.message.warning(this.parseErrors(error.response.data))
      })
    },
    addBccEmail () {
      this.accountSettings.bcc_emails.push({ email: '' })
    }
  },
  validations: {
    accountSettings: {
      bcc_emails: {
        $each: {
          email: {
            required,
            email,
            maxLenght: maxLength(64)
          }
        }
      }
    }
  }
}
</script>